import { createReducer, on } from '@ngrx/store';

import * as _ from 'lodash';

import * as actions from '../actions/task-additional-info-collection.actions';
import * as models from '../../domain/models';

export const taskAdditionalInfoCollectionFeatureKey = 'taskAdditionalInfoCollection';

export interface State {
  loaded: boolean;
  loading: boolean;
  items: Array<models.TaskAdditionalInfo>;
}

const initialState: State = {
  loaded: false,
  loading: false,
  items: null,
};

export const reducer = createReducer(
  initialState,

  on(
    actions.load,
    (state): State => ({
      ...state,
      loading: true,
    })
  ),
  on(
    actions.loadSuccess,
    (state, { payload }): State => ({
      ...state,
      loaded: true,
      loading: false,
      items: _.cloneDeep(payload),
    })
  ),
  on(
    actions.loadFail,
    (state): State => ({
      ...state,
      loaded: true,
      loading: false,
    })
  ),
  on(
    actions.reset,
    (): State => ({
      ...initialState,
    })
  )
);

